import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../components/DashboardLayout";
import { apiRequest } from "../../utils/api";
import { createProvidedUniformForm, listUniformFormEmployees, listUniformTypes } from "../../services/uniformFormApi";

const today = () => new Date().toISOString().slice(0, 10);
const empty = {
  outletId: "",
  employeeId: "",
  employeeCode: "",
  employeeName: "",
  designation: "",
  gender: "",
  mobile: "",
  uniformType: "",
  size: "",
  quantity: 1,
  reason: "",
  remarks: "",
  providedDate: today(),
  providedRemarks: "",
};

const UniformProvidedCreate = () => {
  const nav = useNavigate();
  const [form, setForm] = useState(empty);
  const [outlets, setOutlets] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [types, setTypes] = useState([]);
  const [employeeSearch, setEmployeeSearch] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    apiRequest("/api/admin/settings/outlets", {}, nav).then((r) => setOutlets(r.data || [])).catch((e) => alert(e.message));
    listUniformTypes(nav).then((r) => setTypes(r.data || [])).catch(() => {});
  }, [nav]);

  useEffect(() => {
    if (!form.outletId) { setEmployees([]); return undefined; }
    const timer = setTimeout(() => {
      listUniformFormEmployees({ outletId: form.outletId, search: employeeSearch }, nav)
        .then((r) => setEmployees(r.data || []))
        .catch(() => setEmployees([]));
    }, 300);
    return () => clearTimeout(timer);
  }, [form.outletId, employeeSearch, nav]);

  const change = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const changeOutlet = (e) => {
    setForm({ ...form, outletId: e.target.value, employeeId: "", employeeCode: "", employeeName: "", designation: "", gender: "", mobile: "" });
    setEmployeeSearch("");
  };
  const changeEmployee = (e) => {
    const employeeId = e.target.value;
    const employee = employees.find((item) => String(item.id) === String(employeeId));
    setForm({ ...form, employeeId, employeeCode: employee?.employeeCode || "", employeeName: employee?.name || "", designation: employee?.designation || "", gender: employee?.gender || "", mobile: employee?.mobile || "" });
  };
  const submit = async (e) => {
    e.preventDefault();
    if (saving) return;
    setSaving(true);
    try {
      await createProvidedUniformForm(form, nav);
      nav("/uniform-forms?tab=provided");
    } catch (err) {
      alert(err.message);
      setSaving(false);
    }
  };

  return <DashboardLayout title="Add Provided Uniform"><div className="container-fluid"><div className="card p-4"><div className="d-flex justify-content-between align-items-center mb-3"><h3 className="mb-0">Add Provided Uniform</h3><button type="button" className="btn btn-outline-secondary" onClick={() => nav('/uniform-forms?tab=provided')}>Back</button></div><form onSubmit={submit}><div className="row g-3">
    <div className="col-md-6"><label className="form-label">Outlet</label><select required className="form-select" name="outletId" value={form.outletId} onChange={changeOutlet}><option value="">Select Outlet</option>{outlets.map((o) => <option key={o.id} value={o.id}>{o.branchName || o.name || o.showId}</option>)}</select></div>
    <div className="col-md-6"><label className="form-label">Employee Search</label><input className="form-control" placeholder="Search employee code, name, or mobile" value={employeeSearch} onChange={(e) => setEmployeeSearch(e.target.value)} disabled={!form.outletId}/></div>
    <div className="col-md-6"><label className="form-label">Employee</label><select required className="form-select" value={form.employeeId} onChange={changeEmployee} disabled={!form.outletId}><option value="">Select Employee</option>{employees.map((employee) => <option key={employee.id} value={employee.id}>{employee.employeeCode} - {employee.name}</option>)}</select></div>
    {[['employeeCode', 'Employee ID'], ['employeeName', 'Employee Name'], ['designation', 'Designation'], ['gender', 'Gender'], ['mobile', 'Mobile']].map(([key, label]) => <div className="col-md-6" key={key}><label className="form-label">{label}</label><input className="form-control" value={form[key] || ''} readOnly /></div>)}
    <div className="col-md-6"><label className="form-label">Uniform Type</label><select required className="form-select" name="uniformType" value={form.uniformType} onChange={change}><option value="">Select Uniform Type</option>{types.map((type) => <option key={type.id || type.name} value={type.name}>{type.name}</option>)}</select></div>
    <div className="col-md-6"><label className="form-label">Size</label><input required className="form-control" name="size" value={form.size} onChange={change}/></div>
    <div className="col-md-6"><label className="form-label">Quantity</label><input required min="1" type="number" className="form-control" name="quantity" value={form.quantity} onChange={change}/></div>
    <div className="col-md-6"><label className="form-label">Reason</label><input className="form-control" name="reason" value={form.reason} onChange={change}/></div>
    <div className="col-md-6"><label className="form-label">Request/Entry Remarks</label><textarea className="form-control" rows="3" name="remarks" value={form.remarks} onChange={change}/></div>
    <div className="col-md-6"><label className="form-label">Provided Date</label><input required type="date" className="form-control" name="providedDate" value={form.providedDate} onChange={change}/></div>
    <div className="col-md-6"><label className="form-label">Provided Remarks</label><textarea className="form-control" rows="3" name="providedRemarks" value={form.providedRemarks} onChange={change}/></div>
  </div><button className="btn btn-primary mt-3" disabled={saving}>{saving && <span className="spinner-border spinner-border-sm me-2"/>}{saving ? 'Saving...' : 'Save'}</button></form></div></div></DashboardLayout>;
};

export default UniformProvidedCreate;
